export default __webpack_public_path__ + "static/media/icon-supply-chain-financing.019942e6.png";